// ============================================
// ACTIVE NAVIGATION STORE
// ============================================

import Alpine from 'alpinejs';

export function registerNavigationStore(): void {
    Alpine.store('navigation', {
        activeSection: '',

        isActive(href: string): boolean {
            if (!href || !href.startsWith('#')) return false;
            const sectionId = href.substring(1);

            if (sectionId === '') {
                return this.activeSection === '' || window.scrollY < 100;
            }

            return this.activeSection === sectionId;
        }
    });
}

export function initNavigationTracking(): void {
    document.addEventListener('DOMContentLoaded', () => {
        window.addEventListener('scroll', () => {
            const sections = document.querySelectorAll<HTMLElement>('section[id]');
            let currentSection = '';

            sections.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.clientHeight;
                const scrollPosition = window.scrollY + 100;

                if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                    currentSection = section.getAttribute('id') || '';
                }
            });

            Alpine.store('navigation').activeSection = currentSection;
        });

        window.dispatchEvent(new Event('scroll'));
    });
}
